/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerCard = {
    type: 'array',
    contains: {
        type: 'PlayerCardEntry',
    },
} as const;
